
<form [formGroup]="formMonitoring" (ngSubmit)="save()">
 
    <div class="container">
      <div class="close-btn-fill-area" mat-dialog-close>
        <span class="close-btn">
        </span>
    </div>
        
     <p class="title">{{ 'TITLE_MODAL_PERFORMANCE' | translate}}</p>
    
    <!-- <p class="subtitle">{{'SUBTITLE_REPORT_FIELD' | translate}}</p>
    
     <p class="subsubtitle">Selected</p>-->
    
     
     <p class="otherReportDescription">{{ 'MODAL_PERFORMANCE_LABEL_1' | translate}}:</p>
    
     <!--<mat-form-field appearance="outline" color="white" class="matformSelect">
       
       <mat-select formControlName="isvalid">
         
         <mat-option  [value]="1">True</mat-option>
         <mat-option  [value]="2">False</mat-option>
        
       </mat-select>
      
     </mat-form-field>
    -->

    <section class="example-section">
      <mat-checkbox formControlName="isvalid" class="example-margin">{{ 'MODAL_PERFORMANCE_LABEL_LEYEND' | translate}}</mat-checkbox>
      
    </section>
     
     <p class="otherReportDescription">{{ 'MODAL_PERFORMANCE_LABEL_LEYEND2' | translate}}</p>
    
     <mat-form-field class="full-width" appearance="outline">
     
        <textarea formControlName="comment" matInput></textarea>
      </mat-form-field>
    
      <table class="full-width"  cellspacing="0"><tr>
        <td style="text-align: center;">
            <button class="matbtnTransparent" mat-stroked-button (click)="close()">
              
                {{ 'DIALOG_BACK_CANCEL' | translate}}
                
            </button>
        </td>
        <td style="text-align: center;">
            <button mat-raised-button color="primary">
              
              {{ 'SAVE' | translate}}
                
            </button>
        </td>
      </tr></table>
    
    </div>
    </form>
